module.exports = __webpack_public_path__ + "img/Werder-Bremen.3b894d15.png";